var _style, _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M841.3,486.9c-16.4,16.4-34,30.8-52.3,43.1c-23.3,15.6-47.7,27.8-72.5,36.5c-4.2,1.5-8.4,2.8-12.6,4.1 c-26.8,8.1-53.9,12.2-80.2,12.1c-12.8-0.1-25.4-1.1-37.7-3.1c-28.4-4.7-55.1-14.7-78.8-30.2c-10.9-7.1-21.1-15.3-30.5-24.8 c-9.2-9.2-17.2-19.1-24.2-29.6c-15.6-23.5-25.7-50.2-30.6-78.4c-2.2-12.7-3.3-25.7-3.3-38.9c-0.1-25.6,3.7-52,11.4-78.1 c1.4-4.9,3-9.8,4.7-14.7c8.7-24.8,20.9-49.3,36.5-72.5c12.3-18.3,26.6-35.9,43.1-52.3c2.3-2.3,4.6-4.5,6.9-6.7 c19.5-18.4,40.4-34.1,62.1-46.9c22.8-13.4,46.6-23.7,70.6-30.7c2-0.6,4-1.2,6-1.7c34.2-9.3,68.6-12,101.1-7.9 c3.3,0.4,6.6,0.9,9.9,1.5c28.3,4.8,54.9,15,78.4,30.6c10.5,7,20.4,15,29.6,24.2c9.4,9.4,17.7,19.6,24.8,30.5 c15.5,23.7,25.5,50.4,30.2,78.8c0.5,2.9,0.9,5.8,1.3,8.7c4.1,32.5,1.4,67-7.9,101.1c-0.7,2.7-1.5,5.4-2.3,8.1 c-7,23.2-17.1,46.3-30.1,68.4C880.5,442.2,862.6,465.5,841.3,486.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.2,641.5c0,0,1-1,39.9-39.9s61.7-96,60.7-211.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,888.5l17.1,17.1c11.3,11.3,29.7,11.3,41.1,0l151.3-151.3c9.5-9.5,17-20.8,22-33.3l15.4-38.1l-20.7-20.7 l-20.7-20.7l-38.1,15.4c-12.5,5-23.8,12.5-33.3,22L95.5,830.3c-11.3,11.3-11.3,29.7,0,41.1L112.7,888.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.6,682.9c0,0,1-1,39.9-39.9c38.9-38.9,96-61.7,211.6-60.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 225.3,
    y1: 706.8,
    x2: 294.3,
    y2: 775.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 157.7,
    y1: 774.4,
    x2: 226.8,
    y2: 843.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "429.9,299.4 439.7,289.7 494.2,235.2 548.7,180.7 603.2,126.2 653.8,75.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "421.9,416.5 439.7,398.7 494.2,344.2 548.7,289.7 603.2,235.2 657.7,180.7 712.2,126.2 766.7,71.7  770.9,67.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "452.4,494.9 494.2,453.2 548.7,398.7 603.2,344.2 657.7,289.7 712.2,235.2 766.7,180.7  821.2,126.2 849.3,98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "507.1,549.3 548.7,507.7 603.2,453.2 657.7,398.7 712.2,344.2 766.7,289.7 821.2,235.2  875.7,180.7 903.7,152.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "585.9,579.5 603.2,562.2 657.7,507.7 712.2,453.2 766.7,398.7 821.2,344.2 875.7,289.7  930.2,235.2 933.9,231.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "924.9,349.4 875.7,398.7 821.2,453.2 766.7,507.7 712.2,562.2 703.8,570.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "761,66 766.7,71.7 821.2,126.2 875.7,180.7 930.2,235.2 935.1,240.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "659.8,73.9 712.2,126.2 766.7,180.7 821.2,235.2 875.7,289.7 927.3,341.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "894.8,417.9 875.7,398.7 821.2,344.2 766.7,289.7 712.2,235.2 657.7,180.7 603.2,126.2  583.3,106.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 847.7,
    y1: 479.7,
    x2: 521,
    y2: 153.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "788.9,530 766.7,507.7 712.2,453.2 657.7,398.7 603.2,344.2 548.7,289.7 494.2,235.2 471.2,212.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "716.4,566.5 712.2,562.2 657.7,507.7 603.2,453.2 548.7,398.7 494.2,344.2 439.7,289.7  434.7,284.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "623.6,582.6 603.2,562.2 548.7,507.7 494.2,453.2 439.7,398.7 418.5,377.6  "
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 595.3,
    cy: 812.5,
    r: 125.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479.8,781.6c0,0,4.8-0.2,12.4,1.7c19.7,4.8,34,21.4,37,41.4c2.1,14.1,8.6,27.7,19.6,38.6 c26.3,26.1,69.2,26.6,96,1c28.1-26.8,28.5-71.2,1.2-98.5c-10.9-10.9-24.6-17.4-38.8-19.5c-19.9-2.9-36.3-17.4-41-36.9 c-1.9-7.6-1.7-12.4-1.7-12.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/Tennis.46962dde.svg";
export { ForwardRef as ReactComponent };